import React, { useEffect, useState } from 'react';
import ITemperatures from '../ProfilesTabs/interfaces/Temperatures';
import { InitializeTemperature } from '../ProfilesTabs/helpers/InitializeTemperature';
import { Grid, Typography } from '@material-ui/core';
import { TemperatureFormController } from '../ProfilesTabs/TemperatureFormController';
import { useTranslation } from 'react-i18next';

export const AvailabilityTemperature = props => {
  const { t } = useTranslation();
  const {
    availability,
    index,
    type,
    handleAvailabilityChange,
    errorValidations,
    setErrors,
  } = props;
  const newHoldingTemperature = availability.formTemperatures
    ? { ...availability.formTemperatures }
    : InitializeTemperature();
  const [holdingTemperatures, setHoldingTemperatures] = useState<ITemperatures>(
    newHoldingTemperature,
  );
  const [selectionType, setSelectionType] = useState('');

  useEffect(() => {
    if (availability.formTemperatures) {
      setHoldingTemperatures(prevState => ({
        ...prevState,
        ...availability.formTemperatures,
      }));
    }
  }, [availability.formTemperatures]);

  const setNewTemperatures = (temperatures, selectionType) => {
    setHoldingTemperatures(temperatures);
    setSelectionType(selectionType);
  };

  useEffect(() => {
    handleAvailabilityChange(holdingTemperatures, index, selectionType);
  }, [
    holdingTemperatures.tempMaxF,
    holdingTemperatures.tempMinF,
    selectionType,
  ]);

  return (
    <>
      <Grid item xs={12}>
        <Typography style={{ fontSize: 14, fontWeight: 600 }} align="center">
          {t('holdingProfile.minMaxTemperatures')}
        </Typography>
      </Grid>
      <Grid item xs={12} style={{ marginTop: 10 }}>
        <Typography variant="h6" color="initial">
          {t('equipment.holdingProfileTemperature')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <TemperatureFormController
          temperatures={holdingTemperatures}
          setTemperatures={setNewTemperatures}
          type={type}
          errorValidations={errorValidations}
          setErrors={setErrors}
        />
      </Grid>
    </>
  );
};
